import { Box, keyframes } from '@chakra-ui/react'

interface PulsatingDotProps {
  color?: string
  size?: 'small' | 'large'
}

export function PulsatingDot({ color = 'txtSignalLime', size = 'large' }: PulsatingDotProps) {
  const ringScaleMin = 0.33
  const ringScaleMax = 0.5
  const pulseRing = keyframes`
      0% {
      transform: scale(${ringScaleMin});
    }
      30% {
          transform: scale(${ringScaleMax});
      },
    40%,
    50% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
      `

  const pulseDot = keyframes`
      0% {
      transform: scale(0.9);
    }
    25% {
      transform: scale(1.1);
    }
    50% {
      transform: scale(0.9);
    }
    100% {
      transform: scale(0.9);
    }
      `

  return (
    <Box
      as="div"
      h={size === 'large' ? '16px' : '8px'}
      w={size === 'large' ? '16px' : '8px'}
      ml={1}
      position="relative"
      bgColor={color}
      borderRadius="50%"
      _before={{
        content: "''",
        position: 'relative',
        display: 'block',
        width: '300%',
        height: '300%',
        boxSizing: 'border-box',
        marginLeft: '-100%',
        marginTop: '-100%',
        borderRadius: '50%',
        bgColor: color,
        animation: `1s ${pulseRing} cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite`,
      }}
      _after={{
        animation: `1s ${pulseDot} cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite`,
      }}
    />
  )
}
